<template>
    <div class="creatAccount">
        <div class="icon">
            <i class="el-icon-warning"></i>
        </div>
        <p class="f28">Activate failed</p>
        <p>This activation code is expired, you can click <span @click="send">send again</span></p>
    </div>
</template>
<script>
export default {
    props:{
        backBtn: Boolean
    },
    data(){
        return{
        }
    },
    methods:{
        send(){
            this.$emit('showModule',{type:'next',module:'activate',back:'activateFailed'});
            this.axios.post('/userGroup/user-group/rgUser/sendVerifyCode',{
                userId:this.$store.state.userId,
                service: 1
            })
        }
    }
}
</script>
<style lang="less" scoped>
h2{
    font-size: .28rem;
    font-weight: normal;
    margin-bottom: 0.17rem;
}
p{
    font-size: .16rem;
    margin-bottom: 0.50rem;
    text-align: center;
    span{
        color: #1EC345;
        cursor: pointer;
    }
}
.f28{
    font-size: .28rem;
    margin-bottom: 0.3rem;
}
.icon{
    text-align: center;
    margin-bottom: .30rem;
    font-size: .72rem;
    color: #FAAD14;
}

@media(max-width:1024px){
    h2{
        font-size: .16rem;
        margin-bottom: .1rem;
    }
    p{
        font-size: .12rem;
        margin-bottom: 0.2rem;
    }
}
</style>

